import React from 'react'
import ReactDOM from 'react-dom'
import defaultsDeep from 'lodash/defaultsDeep'
import { DatasetConfiguration } from 'schemaform/src/formcore/services/dataset-configuration'
import { QuerysetConfiguration } from 'schemaform/src/formcore/services/queryset-configuration'
import { ElementDatasetConfig } from '../../services/config/ElementConfigService'

export const FORM_BUILDER_WIDGET_COMPONENT_NAME = 'formbuilder'
export const FORM_BUILDER_WIDGET_ELEMENT_SELECTOR = `div[data-component="${FORM_BUILDER_WIDGET_COMPONENT_NAME}"]`

document.querySelectorAll(FORM_BUILDER_WIDGET_ELEMENT_SELECTOR)
  .forEach(function (element) {
    import('schemaform/src/formbuilder').then(({ default: FormBuilder }) => {
      if (element instanceof HTMLDivElement) {
        const config = ElementDatasetConfig(element)
        const {
          component: name,
          ...attributes
        } = element.dataset
        const props = defaultsDeep(
          QuerysetConfiguration(window.location.search, name),
          DatasetConfiguration(attributes, name),
          config,
        )
        const Component = React.createElement(FormBuilder, props)
        ReactDOM.unmountComponentAtNode(element)
        ReactDOM.render(Component, element)
      } else {
        console.log("Error: Formbuilder must be mounted through a <div> element")
      }
    })
  })
